import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface FlagDTO {
  /** [Optional] */
  ''?: string
  reason?: string
}

// Extended Flag type with value property
interface ExtendedFlag extends FlagDTO {
  value?: {
    disabled?: boolean
  }
}

interface FeatureFlagsState {
  flags: Record<string, ExtendedFlag> | null
  isLoading: boolean
  error: string | null
  setFlags: (flags: Record<string, ExtendedFlag>) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clearFlags: () => void
}

export const useFeatureFlagsStore = create<FeatureFlagsState>()(
  persist(
    (set) => ({
      flags: null,
      isLoading: false,
      error: null,
      setFlags: (flags) => set({ flags, error: null }),
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error, isLoading: false }),
      clearFlags: () => set({ flags: null, error: null, isLoading: false }),
    }),
    {
      name: 'feature-flags-storage', // unique name for localStorage key
      partialize: (state) => ({ flags: state.flags }), // only persist flags, not loading/error states
    },
  ),
)
